import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/lib/site";

export default function FaqSection({ variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <section
      data-testid="faq-section"
      className={`section-lw ${isDark ? "bg-black text-white" : "bg-white text-black"}`}
    >
      <div className="container-lw">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
          <div>
            <div
              className={`eyebrow ${
                isDark ? "text-[#0AB5FF]" : "text-[#4F0DFF]"
              }`}
            >
              <span
                className={`h-1.5 w-1.5 rounded-full ${
                  isDark ? "bg-[#0AB5FF]" : "bg-[#4F0DFF]"
                }`}
              />
              FAQ
            </div>
            <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl">
              Straight answers, <br />
              <span className="text-gradient-lw">for serious operators.</span>
            </h2>
            <p
              className={`mt-6 max-w-md text-[17px] leading-relaxed ${
                isDark ? "text-white/70" : "text-[#4A5359]"
              }`}
            >
              What LotWise Auto handles, why it is more economical than
              in-house, what a visit looks like, and where we serve.
            </p>
          </div>

          <div>
            <Accordion type="single" collapsible className="w-full">
              {FAQ.map((item, idx) => (
                <AccordionItem
                  key={idx}
                  value={`faq-${idx}`}
                  data-testid={`faq-item-${idx}`}
                  className={
                    isDark
                      ? "border-b border-white/10"
                      : "border-b border-black/10"
                  }
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${idx}`}
                    className={`py-6 text-left font-display text-lg font-semibold tracking-tight md:text-xl ${
                      isDark
                        ? "text-white hover:no-underline"
                        : "text-black hover:no-underline"
                    }`}
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent
                    className={`pb-6 text-[15px] leading-relaxed ${
                      isDark ? "text-white/70" : "text-[#4A5359]"
                    }`}
                  >
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
